import "../Pages/ImmunoClustDemoPage/AnalysisSetting.css"
import {Grid} from "@mui/material";
import React from "react";
import {Colors} from "../../resources/Colors";

function AnalysisSettingsColumn({title , topText , image , bg , bottomTitle ,bottomText}) {

    let baseColumnBG = `base-column ${bg || ''}`.trim();
    let immageGridItem = `image-grid-item base-column ${bg || ''}`.trim()

    return <>
        <Grid  className={"base-container"}>
                <Grid item className={"base-column title-column"} >
                    <h4 style={{color: 'white'}}>{title}</h4>
                </Grid>
               <Grid item xs={12} className={baseColumnBG} style={{border:0}}>
                   <p>{topText}</p>
               </Grid>
                <Grid item className={immageGridItem} style={{border:0}}>
                    <img className={"grid-image-uniform"} src={image} alt={"analysis"} width={"auto"}/>
                </Grid>
                <Grid item className={"base-column title-column"} style={{borderRadius:0}}>
                    <h4 style={{color: 'white'}}>{bottomTitle}</h4>
                </Grid>
                <Grid item xs={12} className={baseColumnBG} style={{border:0}}>
                    <p>{bottomText}</p>
                </Grid>
                <Grid item xs={12} className={baseColumnBG} style={{border:0}}>
                    <h4 style={{color: Colors.bioretisBlue}}>{bg === "laboratory" ? "Laboratory" : "BioRetis"}</h4>
                </Grid>
        </Grid>
    </>
}export default AnalysisSettingsColumn;